import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const HowItWorks = () => {
  const steps = [{
    num: '01',
    title: 'Дзвінок',
    desc: 'Безкоштовна консультація. Оцінка стану та підбір оптимального рішення.'
  }, {
    num: '02',
    title: 'Виїзд лікаря / госпіталізація',
    desc: 'Швидке прибуття бригади або організація безпечного трансферу до клініки.'
  }, {
    num: '03',
    title: 'Лікування',
    desc: 'Детоксикація, зняття абстинентного синдрому, медикаментозна терапія.'
  }, {
    num: '04',
    title: 'Підтримка та супровід',
    desc: 'Психологічна допомога, кодування, рекомендації щодо подальшої реабілітації.'
  }];
  return <section id="how-it-works" className="py-24 bg-[#F5F5F5] border-y border-gray-200" data-id="element-156">
      <div className="container mx-auto px-4 md:px-6" data-id="element-157">
        <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-158">
          <div className="lg:w-1/3 lg:sticky lg:top-32 h-fit" data-id="element-159">
            <FadeIn data-id="element-160">
              <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-161">
                Як ми працюємо
              </h2>
              <p className="text-lg text-gray-600" data-id="element-162">
                Прозорий та зрозумілий процес надання допомоги. Ми поруч на
                кожному етапі вашого одужання.
              </p>
            </FadeIn>
          </div>

          <div className="lg:w-2/3" data-id="element-163">
            <div className="flex flex-col gap-6 lg:gap-8" data-id="element-164">
              {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-165">
                  <div className="bg-white border border-gray-200 p-8 flex flex-col sm:flex-row gap-6 items-start sm:items-center transition-colors hover:border-black shadow-sm" data-id="element-166">
                    <div className="text-5xl font-display font-bold text-gray-200 flex-shrink-0" data-id="element-167">
                      {step.num}
                    </div>
                    <div className="flex-grow" data-id="element-168">
                      <h4 className="text-xl font-bold mb-2" data-id="element-169">{step.title}</h4>
                      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-170">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};